import type { BillingNoticeProps } from '#shared/types/billingNotice'

export default function useSeatUpgradeBreakdown(businessId: MaybeRefOrGetter<string>) {
  const getBreakdown = (stats: SeatStats | null | undefined, requestedFullSeats: number): BillingNoticeProps => {
    const available = stats?.full.available ?? 0
    const pendingRemoval = stats?.full.pendingRemoval ?? 0
    const total = stats?.full.total ?? 0

    const fromAvailable = Math.min(requestedFullSeats, available)
    const fromPending = Math.min(requestedFullSeats - fromAvailable, pendingRemoval)
    const newlyPurchased = requestedFullSeats - fromAvailable - fromPending

    return {
      businessId: toValue(businessId),
      currentSeatTotal: total,
      totalAvailable: available,
      fromAvailable,
      fromPending,
      newlyPurchased,
      nextPeriodSeatTotal: total - pendingRemoval + fromPending + newlyPurchased,
    }
  }

  return { getBreakdown }
}
